


































































import Vue from "vue";
import Component from "vue-class-component";
import api from "@/ts/functions";
import func from "@/ts/FormFunctions";

@Component
export default class FormSearch extends Vue {
    name: string = "FormSearch";
    isLoading: boolean = true;

    searchType: string = "";
    applicationNumber: string = "";
    facilityId: string = "";
    lastFacilityId: string = "";
    lastApplicationNumber: string = "";
    searchTypeDisplay: string = "";
    searchTypeLabel: string = "";
    searchTypeTitle: string = "";
    sourceUrl: string = "";
    showPdf: boolean = false;
    permits: any = null;

    noResultError: string = "";
    get isNoResult(): boolean {
        return this.noResultError !== "";
    }

    mounted() {
        this.searchType = this.$route.params.searchType;
        if (this.searchType === "Permits" || this.searchType === "Renewal") {
            this.searchTypeLabel = "Please Enter Your Permit Application Number";
            this.searchTypeDisplay = "Permit Application";
            this.searchTypeTitle = "Permit Application";
        } else if (this.searchType === "PermitPdf") {
            this.searchTypeLabel = "Please Enter Your Facility Id";
            this.searchTypeDisplay = "Permit Lookup";
            this.searchTypeTitle = "Permit Lookup";
        }
        else if (this.searchType === "RockCrushingRenewal") {
          this.searchTypeLabel = "Please Enter Your Original Permit Number";
            this.searchTypeDisplay = "Original Permit";
            this.searchTypeTitle = "Permit Renewal";
        }

        this.isLoading = false;
    }

    search(): void {
        if (this.applicationNumber == "") {
            this.lastApplicationNumber = this.applicationNumber;
            this.showPdf = false;
            return;
        }
        if (this.applicationNumber == this.lastApplicationNumber) {
            return;
        }
        this.isLoading = true;
        if (this.searchType === "PermitPdf") {
            this.permits = null;
            this.showPdf = false;
            api.getFacilityPermits(this.applicationNumber)
                .then((res) => {
                    if (res.isSuccess) {
                        var permitSearch: any = res;
                        this.permits = permitSearch.data;
                        this.isLoading = false;
                        this.noResultError = "";
                    } else {
                        this.isLoading = false;
                        this.noResultError = "No approved permits were found for the given facility id.";
                    }
                })
        } else {
            if (this.searchType == "Renewal" || this.searchType == "RockCrushingRenewal") {
                api.GetApprovedPermit(this.applicationNumber)
                    .then(result => {
                        var res: any = result;
                        if (res.isSuccess == false) {
                            this.isLoading = false
                            this.noResultError = "No approved permit found with the given permit number";
                            return;
                        }
                    })
            }
            api.searchApplication(this.applicationNumber, this.searchType)
                .then(result => {
                    if (result.isSuccess) {
                        if (this.searchType === "Renewal") {
                            let applicationName = 'Renewal' + result.message as string;
                            this.isLoading = false;
                            this.$router.push({ name: applicationName, params: { applicationNumber: this.applicationNumber } })
                        }
                        else if (this.searchType === "RockCrushingRenewal"){
                          this.isLoading = false;
                          this.$router.push({ name: 'RockCrushingRenewal', params: { applicationNumber: this.applicationNumber } })
                        }
                        else {
                            let applicationName = result.message as string;
                            this.isLoading = false
                            this.$router.push({ name: applicationName, params: { applicationNumber: this.applicationNumber } });
                        }
                    } else {
                        this.isLoading = false
                        this.noResultError = result.message as string;
                    }
                })
        }
    }

    loadPdf(permitNumber: string): void {
        api.getPermitPdf(permitNumber)
            .then((res) => {
                if (String(res) === "") {
                    this.isLoading = false
                    this.noResultError = "Permit Not Found";
                }
                this.sourceUrl = `${window.location.protocol}//${window.location.hostname}`
                    + `${window.location.port ? `:${window.location.port}` : ''}/SolidWaste/api/Permit/Get?permitNumber=${permitNumber}`
                this.showPdf = true;
                this.isLoading = false
                this.isLoading = false
                this.noResultError = "";
            })          
    }

    formatDate(dateString: string): string{
        var date: Date = new Date(dateString);
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }

    cancel(): void {
        this.$router.push({ name: 'Permits' });
    }
}
